import React from "react";

interface IProps {
  title?: React.ReactNode;
  /** Sits opposite the title, e.g. the status tag. */
  extra?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

/** One block of the appointment detail; blocks without data are left out by the caller. */
export default function DetailCard({ title, extra, className = "", children }: IProps) {
  return (
    <section className={`flex flex-col gap-3 p-4 rounded-2xl border border-solid border-common-divider bg-common-white ${className}`}>
      {title || extra ? (
        <div className="flex items-center justify-between gap-3">
          {title ? <h3 className="m-0 text-base font-semibold font-['Inter'] text-common-maintext">{title}</h3> : <span />}
          {extra}
        </div>
      ) : null}

      {children}
    </section>
  );
}
